export enum VerseDelayUnmountEnum {
  MOUNTED = 'mounted',
  EXITING = 'exiting',
  UNMOUNTED = 'unmounted',
  MOUNTING = 'mounting',
}
